<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { onBeforeUnmount, watch } from 'vue'
import { useFairPageLoaderStore } from '@/features/page-loader/store'
import FairPageLoaderMark from './FairPageLoaderMark.vue'

const loader = useFairPageLoaderStore()
const { visible, sessionId } = storeToRefs(loader)

function syncScrollLock(locked: boolean) {
  if (typeof document === 'undefined') return
  document.documentElement.classList.toggle('fair-page-loader-open', locked)
}

watch(
  visible,
  (isVisible) => {
    syncScrollLock(isVisible)
  },
  { immediate: true },
)

onBeforeUnmount(() => {
  syncScrollLock(false)
})
</script>

<template>
  <Teleport to="body">
    <Transition name="fair-page-loader">
      <div
        v-if="visible"
        class="fair-page-loader"
        role="status"
        aria-live="polite"
        aria-busy="true"
        aria-label="Loading"
      >
        <FairPageLoaderMark :replay-key="sessionId" :size="144" />
      </div>
    </Transition>
  </Teleport>
</template>
